module.exports = __webpack_public_path__ + "static/media/harmon-hall-grey.10ef8dea.svg";